import React, { ReactNode } from 'react';
import { ArrowLeft } from 'lucide-react';

interface MainHeadingProps {
    title: string | ReactNode;
    description?: ReactNode;
    actionLabel?: string;
    actionIcon?: ReactNode;
    onAction?: () => void;
    isActionDisabled?: boolean;
    showBack?: boolean;
    onBack?: () => void;
    children?: ReactNode;
}

import { IconTooltip } from './IconTooltip';

export const MainHeading: React.FC<MainHeadingProps> = ({
    title,
    description,
    actionLabel,
    actionIcon,
    onAction,
    isActionDisabled = false,
    showBack,
    onBack,
    children
}) => {
    return (
        <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-border pb-6 mb-6">
            <div className="flex items-center gap-4">
                {showBack && (
                    <IconTooltip content="Go Back" side="right">
                        <button
                            onClick={onBack}
                            className="p-2 rounded-full hover:bg-secondary transition-colors cursor-pointer"
                            type="button"
                        >
                            <ArrowLeft className="w-5 h-5 text-muted-foreground" />
                        </button>
                    </IconTooltip>
                )}
                <div>
                    <h1 className="text-2xl font-bold tracking-tight text-foreground flex items-center gap-3">
                        {title}
                    </h1>
                    {description && (
                        <div className="text-sm text-muted-foreground mt-1">
                            {description}
                        </div>
                    )}
                </div>
            </div>

            <div className="flex items-center gap-2 shrink-0">
                {children}

                {actionLabel && onAction && (
                    <button
                        className={`flex items-center justify-center w-full gap-2 h-9 px-4 rounded-md bg-primary text-primary-foreground text-sm font-medium hover:bg-primary/90 transition-colors shadow-sm disabled:opacity-50 disabled:cursor-not-allowed cursor-pointer`}
                        onClick={onAction}
                        type="button"
                        disabled={isActionDisabled}
                    >
                        {actionIcon}
                        {actionLabel}
                    </button>
                )}
            </div>
        </div>
    );
};
